import React from "react";
import { formatujPercentoBezZnamienkaText, eur } from "../../utils/formatovanie";

const InvestovanieVystupKarta = React.forwardRef(function InvestovanieVystupKarta({
  invOpen,
  invVystupPS,
  invHorizont,
  invZhodnotenie,
  vysledokInvestovania,
  fmtMesiace,
  rozdielMesiacov,
}, ref) {
  if (!invOpen) return null;

  return (
    <div ref={ref} className="card-section card-section--inv-vystup">
      <h2>Sporenie / investovanie</h2>
      
                  {!invVystupPS ? (
                    <>
                    <h3 className="subhead">Investovanie bez predčasného splatenia</h3>
                    <div className="pp-text">
                      <div className="pp-riadky">
                        <div className="pp-riadok">
                          <span className="pp-k">Stav sporenia/investície po {invHorizont} r:</span>
                          <span className="pp-v">
                            {vysledokInvestovania ? `${eur(Math.round(vysledokInvestovania.konecnyStavBezPS))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok sub">
                          <span className="pp-k">z toho vklady:</span>
                          <span className="pp-v">
                            {vysledokInvestovania ? `${eur(Math.round(vysledokInvestovania.celkoveVklady))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok sub">
                          <span className="pp-k">z toho výnos:</span>
                          <span className="pp-v">
                            {vysledokInvestovania ? `${eur(Math.round(vysledokInvestovania.celkovyVynos))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Priemerné ročné zhodnotenie:</span>
                          <span className="pp-v">{formatujPercentoBezZnamienkaText(invZhodnotenie)} p.a.</span>
                        </div>
                      
                      </div>
                    </div>
                      </>
                      ) : (
                      <>
                        <h3 className="subhead">Investovanie s predčasným splatením</h3>
                        <div className="pp-text">
                          <div className="pp-riadky">
                            <div className="pp-riadok">
                              <span className="pp-k">Predčasné splatenie hypotéky:</span>
                              <span className="pp-v">
                                 {vysledokInvestovania?.mesiacSplatenia
                                  ? `${fmtMesiace(vysledokInvestovania.mesiacSplatenia)} (m: ${vysledokInvestovania.mesiacSplatenia})`
                                  : '-'}
                              </span>
                            </div>
                            <div className="pp-riadok">
                              <span className="pp-k">Splatené skôr o:</span>
                              <span className="pp-v">
                                {vysledokInvestovania?.mesiacSplatenia ? rozdielMesiacov(vysledokInvestovania.usetreneMesiace) : '-'}
                              </span>
                            </div>
                            <div className="pp-riadok">
                              <span className="pp-k">Zostatok sporenia/investície po PS:</span>
                              <span className="pp-v">
                                {vysledokInvestovania?.mesiacSplatenia
                                  ? `${eur(Math.round(vysledokInvestovania.zostatokPoSplateni))} €`
                                  : '-'}
                              </span>
                            </div>
                            <div className="pp-riadok">
                              <span className="pp-k">Priemerné ročné zhodnotenie:</span>
                              <span className="pp-v">{formatujPercentoBezZnamienkaText(invZhodnotenie)} p.a.</span>
                            </div>
                          </div>
                        </div>
                       </>
                       )}
    </div>
  );
});

export default InvestovanieVystupKarta;